import React from "react";
import Swal from "sweetalert2";
import "./App.scss";
import { Provider as AuthProvider } from "./contexts/authContext";
import { Provider as LangProvider } from "./contexts/langContext";
import HomePage from "./pages/HomePage";
import WelcomePage from "./pages/WelcomePage";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./services/msalService";

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <LangProvider>
        <AuthProvider>
          <WelcomePage />
          <HomePage />
        </AuthProvider>
      </LangProvider>
    </MsalProvider>
  );
}
// for prod
export default App;
